export default {
  defaulteApi: {
    host: process.env.VUE_APP_API_defaulteApi,
    token: true,
    path: {
      getuserpermissionslist: '/api/examscore/getuserpermissionslist', // 报表中心角色权限列表
      mainClassOrCorse: '/edu/exammain/mainclassorcorse', // 获取试卷科目名称，以及考试科目，班级下拉列表
      studentscoredetaillist: '/api/singlescoredata/studentscoredetaillist', // 学生答题明细---旧
      getstudentscoredetaillist: '/api/v1/reportnew/getstudentscoredetaillist', // 学生答题明细---新
      quartileListUrl: '/api/examscore/getquartilelist', // 四分位分析---旧
      studentscoredetaillistprint:
        '/api/singlescoredata/studentscoredetaillistprint', // 导出学生答题明细-excel
      studentscoredetaillistzip:
        '/api/singlescoredata/studentscoredetaillistzip', // 导出学生答题明细-ziptoFixed
      studentobjectivequestiondetail:
        '/api/singlescoredata/studentobjectivequestiondetail', // 客观题明细
      studentobjectivequestiondetailprint:
        '/api/singlescoredata/studentobjectivequestiondetailprint', // 学生客观题明细-excel
      studentobjectivequestiondetailzip:
        '/api/singlescoredata/studentobjectivequestiondetailzip', // 学生客观题明细-zip-4
      scoreListUrl: '/api/singlescoredata/scorelist', // 试卷整体分析
      scorePrint: '/api/singlescoredata/scoreprint', // 试卷分析导出
      questionScoreRateList: '/api/singlescoredata/questionscoreratelist', // 小题得分率
      questionscoreratelistprint:
        '/api/singlescoredata/questionscoreratelistprint', // 导出小题得分率
      questionscoreratelistzip: '/api/singlescoredata/questionscoreratelistzip', // 导出小题得分率zip
      objectiveQuestionscoreListUrl: '/api/singlescoredata/objectivequestion', // 客观题平均分
      objectivequestionprint: '/api/singlescoredata/objectivequestionprint', // 导出客观题平均分
      objectivequestionzip: '/api/singlescoredata/objectivequestionzip', // 导出客观题平均分zip
      superAveragescoreListUrl: '/api/singlescoredata/superaverage', // 学科超均率
      questionScoreListUrl: '/api/singlescoredata/questionscorelist', // 学生小题得分
      questionprint: '/api/singlescoredata/questionprint', // 导出小题得分
      questionzip: '/api/singlescoredata/questionzip', // 导出小题得分zip
      scoreClassListUrl: '/api/singlescoredata/scoreclasslist', // 班级单科成绩
      exportscoreclass: '/api/singlescoredata/exportscoreclass', // 导出班级单科成绩
      exportscoreclasszip: '/api/singlescoredata/exportscoreclasszip', // 导出班级单科成绩zip
      scoreSegmentListUrl: '/api/singlescoredata/scoresegmentlist', // 班级分数段
      exportscoresegment: '/api/singlescoredata/exportscoresegment', // 导出班级分数段
      exportscoresegmentzip: '/api/singlescoredata/exportscoresegmentzip', // 导出班级分数段zip
      segmentSetailListUrl: '/api/singlescoredata/segmentsetaillist', // 班级分数段详情
      konwPointListUrl: '/api/singlescoredata/knowledgepointlist', // 知识点得分率
      exportkonwPointList: '', // 导出知识点得分率
      exportkonwPointListzip: '', // 导出知识点得分率zip
      wrongBookListUrl: '/api/singlescoredata/wrongbooklist', // 学生错题集
      wrongBookQuestionListUrl: '/edu/score/course/wrongBookQuestionList.api', // 学生错题集详情
      studentScoreListUrl: '/api/examscore/getstudenttranscript', // 学生成绩单
      // exportstudentScoreList: '/api/examscore/exportstudenttranscript', // 导出学生成绩单excel 旧得不用了
      exportstudentScoreListZip: '/api/examscore/exportstudenttranscriptzip', // 导出学生成绩单zip
      studentLevelListUrl: '/api/examscore/getstuhorizontaldistribution', // 学生水平分布
      exportStudentLevelList: '/api/examscore/exportstuleveldistribution', // 导出学生水平分布excel
      exportStudentLevelListZip: '/api/examscore/exportstuleveldistributionzip', // 导出学生水平分布zip
      studentEligibleListUrl: '/api/examscore/getstudentlevelstandard', // 学生水平达标
      exportstudentEligibleList: '/api/examscore/exportstudentlevelstandard', // 导出学生水平达标excel
      exportstudentEligibleListZip:
        '/api/examscore/exportstudentlevelstandardzip', // 导出学生水平达标zip
      classAvgScoreListUrl: '/api/examscore/classavgscorelist', // 班级学科均分
      exportclassAvgScoreList: '/api/examscore/classavgscorelistexport', // 导出班级学科均分excel
      exportclassAvgScoreListZip: '/api/examscore/classavgscorelistexportzip', // 导出班级学科均分zip
      studentAdReListUrl: '/api/examscore/studentadreList', // 学生进退步
      exportstudentAdReList: '/api/examscore/studentadrelistexport', // 导出学生进退步excel
      exportstudentAdReListZip: '/api/examscore/studentadrelistzip', // 导出学生进退步zip
      pointListUrl: '/api/examscore/getheadcountsegmentation', // 人数分段
      exportpointList: '/api/examscore/exportnumberofsegments', // 导出人数分段excel
      exportpointListZip: '/api/examscore/exportnumberofsegmentszip', // 导出人数分段zip
      lineListUrl: '/api/examscore/linelist', // 上线策略下拉列表
      doubleLineListUrl: '/api/examscore/doublelinelist', // 学科双上线率
      exportdoubleLineList: '/api/examscore/doublelinelistexport', // 导出学科双上线率excel
      studentLineListUrl: '/api/examscore/studentlinelist', // 学生双上线率
      exportstudentLineList: '/api/examscore/studentlinelistexport', // 导出学生双上线率excel
      studentContributionListuRL: '/api/examscore/studentcontributionlist', // 学科贡献率/命中率
      exportstudentContributionList:
        '/api/examscore/studentcontributionlistexport', // 导出学科贡献率/命中率excel
      enterYearList: '/edu/exammain/enteryearlist', // 入学年份列表
      examList: '/api/v1/exam/getexamlist', // 试卷列表
      examInfoList: '/api/v1/exam/getexaminfolist',
      getreportexaminfolist: '/api/v1/exam/getreportexaminfolist', // 新策略校考考试列表
      getreportexamgroupinfolist: '/api/v1/exam/getreportexamgroupinfolist', // 新策略获取组
      getExamcomparison: '/api/v1/exam/examcomparison', // 获取考试对比数据
      unionexamcomparison: '/api/v1/exam/unionexamcomparison', // 获取联考考试对比数据
      saveexamcomparison: '/api/v1/exam/saveexamcomparison', // 保存考试数据对比
      saveunionexamcomparison: '/api/v1/exam/saveunionexamcomparison ', // 保存联考考试数据对比
      getexaminfochildlist: '/api/dataunion/exam/getexaminfochildlist', // 区域联考 获取组
      getschoolexaminfochildlist:
        '/api/dataunion/exam/getschoolexaminfochildlist', // 校级联考 获取组
      learningExamList: '/api/learning/getExamReport', // 学情分析试卷列表
      mainInfoListUrl: '/api/learning/getExamMainInfo', // 学情分析详情表头信息
      classEchartsUrl: '/api/learning/examSummary', // 学情分析详情图表
      exportexamclassdivide: '/api/learning/exportexamclassdivide', // 学情分析下载班级赋分
      getclasslist: '/api/studentportraits/getclasslist', // 学生画像 班级列表
      getgradelist: '/api/studentportraits/getgradelist', // 学生画像  年级列表
      studentListUrl: '/api/studentportraits/getstudentlist', // 学生画像  年级列表
      studentInfoUrl: '/api/studentportraits/getstudentinfo', // 学生画像  学生信息
      getstudentstable: '/api/studentportraits/getstudentstable', // 学生画像 单科考试平稳度跟踪
      upAvgScoreListUrl: '/api/studentportraits/getupavgscore', // 学生画像  学生均超值
      getscorereport: '/api/studentportraits/getscorereport', // 学生画像 成绩表
      geteduclasslist: '/edu/exammain/getclasslist', // 获取考试下的班级
      getexamclasssubjects: '/edu/exammain/getexamclasssubjects', // 获取考试下的班级的所有科目
      papercommentlist: '/api/singlescoredata/papercommentlist', //获取papercommentlist
      papercommentquestionstat: '/api/singlescoredata/papercommentquestionstat', //讲评统计
      getpapercommentexamlist: '/api/singlescoredata/getpapercommentexamlist', // 试卷讲评列表页查询接口
      getexamstudentscorerank: '/api/examscore/getexamstudentscorerank', // 全年级学生成绩
      getstudentscoredetail: '/api/studentscore/getstudentscoredetail', //学生题目得分明细
      exportstudentscorerank: '/api/examscore/exportstudentscorerank', // 导出全年级学生成绩
      getstudentsinglescore: '/api/studentscore/getstudentsinglescore', // 单科成绩单
      exportstudentsinglescore: '/api/studentscore/exportstudentsinglescore', // 导出单科成绩单
      getclassscores: '/api/studentscore/getclassscores', // 班级总报表
      getscoresectionstat: '/api/singlescoredata/getscoresectionstat', // 分段统计
      questionscoreratelistv2: '/api/singlescoredata/questionscoreratelistv2', // 小分表
      exportstudentscoredetail: '/api/studentscore/exportstudentscoredetail', // 导出学生成绩细分表
      getexamonlinerate: '/api/examscore/getexamonlinerate', //获取上线率
      exportclassscores: '/api/studentscore/exportclassscores', // 导出班级总报表
      getscoresectionstatprint: '/api/singlescoredata/getscoresectionstatprint', // 导出分段统计表
      questionscoreratelistv2print:
        '/api/singlescoredata/questionscoreratelistv2print', // 导出小分表
      exportonlinerate: '/api/examscore/exportonlinerate', //导出线上率excel
      competencylevel: '/edu/exammain/competencylevel', //学科能力层次
      competencylevelexport: '/edu/exammain/competencylevelexport', //学科能力层次下载
      classquestionscorelist: '/api/singlescoredata/classquestionscorelist', //班级小题得分-2
      exportclassquestionscore: '/api/singlescoredata/exportclassquestionscore', //导出班级小题得分
      anabyreason: '/api/singlescoredata/wrongreason/anabyreason', //错因维度
      anabystudent: '/api/singlescoredata/wrongreason/anabystudent', //学生维度
      updateswitchstatus: '/edu/exammain/updateswitchstatus', //下发成绩,
      getstudenttopicwrongdetail: '/api/examreport/getstudenttopicwrongdetail', //学生题目层次错题表
      exportstudenttopicwrongdetail:
        '/api/examreport/exportstudenttopicwrongdetail', //导出层次错题
      getscoresectionstatallprint:
        '/api/singlescoredata/getscoresectionstatallprint', //分段统计整体导出
      competencylevelcomp: '/edu/exammain/competencylevelcomp', //层次得分率
      competencylevelcompbyseids: '/edu/exammain/competencylevelcompbyseids', //层次得分率 new
      competencylevelcompexport: '/edu/exammain/competencylevelcompexport', //导出层次得分率
      getnewexamonlinerate: '/api/examscore/threeratecontrastive', //三率对比
      exportnewonlinerate: '/api/examscore/threeratecontrastivereport', //导出三率对比
      // getscorescatterdiagram: '/api/singlescoredata/getscorescatterdiagram', //单科成绩散点图
      competencylevelcompbyseidsexport:
        '/edu/exammain/competencylevelcompbyseidsexport', //导出层次得分率 new
      examlistforsys: '/edu/exammain/examlistforsys',
      getorglist: '/api/scoreexport/getorglist', //通知书获取班级列表
      getstudentlist: '/api/scoreexport/getstudentlist', //通知书获取学生列表
      getsendwordspeed: '/api/scoreexport/getsendwordspeed', //获取通知书进度列表
      getfamilyreportcoption: '/api/scoreexport/getfamilyreportcoption', //下载通知书选择考试列表
      exportfamilyreport: '/api/scoreexport/exportfamilyreport', //下载通知书
      getsendwordtemplatelist: '/api/scoreexport/getsendwordtemplatelist', // 通知书---获取模板信息
      getsendwordinfo: '/api/scoreexport/getsendwordinfo', // 通知书---获取学生寄语详情
      createsendwordone: '/api/scoreexport/createsendwordone', // 通知书---添加教师寄语
      setsendwordone: '/api/scoreexport/setsendwordone', // 通知书---编辑寄语
      getclasssubject: '/api/v1/exam/getclasssubject', //获取单科考试和班级
      datacentergetclasslist: '/api/v1/exam/getclasslist', //获取全科考试和班级
      getreportinfo: '/api/v1/report/getreportinfo', //下载报表
      getexamlist: '/api/dataunion/exam/getexamlist', //联考获取考试名称下拉框
      getschoolexamlist: '/api/dataunion/exam/getschoolexamlist', //校端联考获取考试名称下拉框
      getexaminfolist: '/api/dataunion/exam/getexaminfolist', //联考获取考试列表
      getschoolexaminfolist: '/api/dataunion/exam/getschoolexaminfolist', //校端联考考试列表
      updateUnionSwitch: '/api/dataunion/exam/updateswitchstatus', //校端联考家长可见开关
      updatesUnionStatus: '/api/dataunion/exam/updatestatus ', //联考排名和 学校可见
      exportstudenttranscript: '/api/dataunion/report/exportstudenttranscript', //下载校端联考报表
      downloadunionreport: '/api/dataunion/report/downloadunionreport', //下载教育局端联考列表
      getexampaperquestiontypeanalyse:
        '/api/singlescoredata/getexampaperquestiontypeanalyse', //题型分布（试卷讲评）
      getexampaperquestionanalyse:
        '/api/singlescoredata/getexampaperquestionanalyse', // 试题分析（试卷讲评）
      papercommontquestionitemstat:
        '/api/singlescoredata/papercommontquestionitemstat', // 试题解析（试卷讲评）
      papercommentquestionstudentstat:
        '/api/singlescoredata/papercommentquestionstudentstat', // 试题学生得分解析，答题情况 （试卷讲评）
      classRangeScore: '/api/examscore/classRangeScore', // 获取 和设置 小题区间分数
      getdownloadexamlist: '/api/v1/exam/getdownloadexamlist', //下载中心
      exportmultireport: '/api/v1/reportnew/exportmultireport', //总分下载
      exportsinglereport: '/api/v1/reportnew/exportsinglereport', //单科下载
      // 下载新得报表

      exportscoretrend: '/api/v1/reportnew/exportscoretrend', // 试卷得分趋势报表
      exportscoreprintsingle: '/api/v1/reportnew/exportscoreprintsingle', // 获取试卷整体分析
      reportnewexportstudenttranscript:
        '/api/v1/reportnew/exportstudenttranscript', //下载学生成绩单
      exportoriginaltranscript: '/api/v1/reportnew/exportoriginaltranscript',
      exportfinaltranscript: '/api/v1/reportnew/exportfinaltranscript',
      exportscorelineanalysis: '/api/v1/reportnew/exportscorelineanalysis', //下载上线分析表
      exportboundarystudentsstatistics:
        '/api/v1/reportnew/exportboundarystudentsstatistics',
      getavgscoretable: '/api/v1/reportnew/getavgscoretable',
      exportfourpoint: '/api/v1/reportnew/exportfourpoint', //四率下载
      getrankseg: '/api/v1/reportnew/getrankseg',
      getavgranktable: '/api/v1/reportnew/getavgranktable',
      getscoreseg: '/api/v1/reportnew/getscoreseg', //获取分数段
      questionScoreRate: '/api/v1/reportnew/questionScoreRate', // 试卷整体分析 -- 小题得分率 -- 折线图
      testPaperOverallAnalysis: '/api/v1/reportnew/testPaperOverallAnalysis', // 获取试卷整体分析页面展示 -- table
      scoretrendimage: '/api/v1/reportnew/scoretrendimage', // 试卷得分趋势---折线图
      scoretrend: '/api/v1/reportnew/scoretrend', // 试卷得分趋势列表 --- table
      subtopicScore: '/api/v1/reportnew/subtopicScore', // 试题小分表
      gettestscoretrend: '/api/v1/reportnew/gettestscoretrend', // 单科报表 -- 试题得分率趋势
      studenttranscriptlist: '/api/v1/reportnew/studenttranscriptlist', //获取学生成绩单 --新
      getquartilelist: '/api/v1/reportnew/getquartilelist', //获取四分位 --新
      getstudenttranscript: '/api/v1/reportnew/getstudenttranscript', //获取学生成绩单 --新
      getavgscorelist: '/api/v1/reportnew/getavgscorelist', //获取班级均分分析
      getavgranklist: '/api/v1/reportnew/getavgranklist', //获取均位分析 --新
      getscoreseglist: '/api/v1/reportnew/getscoreseglist', // 获取分数段数据--- 新
      getrankseglist: '/api/v1/reportnew/getrankseglist', //位次段分析
      getfourpointlist: '/api/v1/reportnew/getfourpointlist', //获取四率
      getscorelineanalysis: '/api/v1/reportnew/getscorelineanalysis', //上线分析
      getboundary: '/api/v1/reportnew/getboundarystudentsstatistics', //临界生统计
      getboundarystudentlist: '/api/v1/reportnew/getboundarystudentlist', //临界生表格数据
      exportavgscoretable: '/api/v1/reportnew/exportavgscoretable', //下载均分分析表 --新
      exportavgranktable: '/api/v1/reportnew/exportavgranktable', //下载均位分析表
      exportscoreseg: '/api/v1/reportnew/exportscoreseg', //下载分数段分析表
      exportrankseg: '/api/v1/reportnew/exportrankseg', //下载位次段分析表
      exportstudentscoredetaillistdownload:
        '/api/v1/reportnew/exportstudentscoredetaillistdownload', //答题明细报表下载
      studentScoreScatterPoint: '/api/v1/reportnew/studentScoreScatterPoint', //学生成绩单列表
      exportquestionprintsingle: '/api/v1/reportnew/exportquestionprintsingle', //下载试题小分表
      getdistinctiveclasssubject: '/api/v1/exam/getdistinctiveclasssubject', //校端校考获取组别班级科目
      //局端联考接口
      getquartilelistUnion: '/api/dataunion/reportnew/getquartilelist', //四分位
      getstudentscoredetaillistUnion:
        '/api/dataunion/reportnew/getstudentscoredetaillist', //学生答题明细
      getavgscorelistUnion: '/api/dataunion/reportnew/getavgscorelist', //获取均分分析表
      exportstudentscoredetaillistdownloadUnion:
        '/api/dataunion/reportnew/exportstudentscoredetaillistdownload', //答题明细下载
      reportnewexportstudenttranscriptUnion:
        '/api/dataunion/reportnew/exportstudenttranscript', //下载学生成绩单
      studentScoreScatterPointUnion:
        '/api/dataunion/reportnew/studentScoreScatterPoint', //学生成绩单列表
      studenttranscriptlistUnion:
        '/api/dataunion/reportnew/studenttranscriptlist', //获取学生成绩单 --新
      questionScoreRateUnion: '/api/dataunion/reportnew/questionScoreRate', // 试题得分率 -- 折线图
      exportscoreprintsingleUnion:
        '/api/dataunion/reportnew/exportscoreprintsingle', // 获取试卷整体分析
      testPaperOverallAnalysisUnion:
        '/api/dataunion/reportnew/testPaperOverallAnalysis', // 获取试卷整体分析页面展示 -- table
      subtopicScoreUnion: '/api/dataunion/reportnew/subtopicScore', // 试题小分表
      exportquestionprintsingleUnion:
        '/api/dataunion/reportnew/exportquestionprintsingle', //下载试题小分表
      exportscoretrendUnion: '/api/dataunion/reportnew/exportscoretrend', // 试卷得分趋势报表
      scoretrendimageUnion: '/api/dataunion/reportnew/scoretrendimage', // 试卷得分趋势---折线图
      scoretrendUnion: '/api/dataunion/reportnew/scoretrend', // 试卷得分趋势列表 --- table
      getfourpointlistUnion: '/api/dataunion/reportnew/getfourpointlist', //获取四率列表
      exportfourpointUnion: '/api/dataunion/reportnew/exportfourpoint', //下载四率列表
      getscorelineanalysisUnion:
        '/api/dataunion/reportnew/getscorelineanalysis', //上线分析
      exportscorelineanalysisUnion:
        '/api/dataunion/reportnew/exportscorelineanalysis', //下载上线分析表
      getdistinctlistUnion: '/api/dataunion/reportnew/getdistinctlist', //获取局端区分组列表
      getdistinctcourselistUnion:
        '/api/dataunion/reportnew/getdistinctcourselist', //获取有组别或无组别的科目列表
      getscoreseglistUnion: '/api/dataunion/reportnew/getscoreseglist', //获取分数段表
      exportscoresegUnion: '/api/dataunion/reportnew/exportscoreseg', //下载分数段表
      getexammaininfoUnion: '/api/dataunion/exam/getexammaininfo', //获取概览数据
      exportavgscoretableUnion: '/api/dataunion/reportnew/exportavgscoretable', //下载均分分析表
      getrankseglistUnion: '/api/dataunion/reportnew/getrankseglist', //获取位次段
      exportranksegUnion: '/api/dataunion/reportnew/exportrankseg', //下载位次段表
      getnewreportcheck: '/api/dataunion/reportnew/getnewreportcheck', //区域段联考获取报表策略勾选配置

      //校端联考接口
      getfourpointlistSchoolUnion:
        '/api/dataunion/reportnew/getschoolfourpointlist', //获取校端联考四率表
      exportfourpointSchoolUnion:
        '/api/dataunion/reportnew/exportschoolfourpoint', //下载四率表
      getscorelineanalysisSchoolUnion:
        '/api/dataunion/reportnew/getschoolscorelineanalysis', //获取上线分析表
      exportscorelineanalysisSchoolUnion:
        '/api/dataunion/reportnew/exportschoolscorelineanalysis', //下载上线分析表
      getdistinctiveclassSchoolUnion:
        '/api/dataunion/reportnew/getdistinctiveclass', //区分组班级联动
      getclasssubjectSchoolUnion: '/api/dataunion/reportnew/getclasssubject', //获取班级和科目
      // 联考快速下载
      unionexportmultireport: '/api/dataunion/reportnew/exportmultireport', //总分下载
      unionexportsinglereport: '/api/dataunion/reportnew/exportsinglereport', //单科下载
      getavgscorelistSchoolUnion:
        '/api/dataunion/reportnew/getschoolavgscorelist', //获取均分分析
      exportavgscoretableSchoolUnion:
        '/api/dataunion/reportnew/exportschoolavgscoretable', //下载均分分析
      getquartilelistSchoolUnion:
        '/api/dataunion/reportnew/getschoolquartilelist', //获取四分位表
      getstudentscoredetaillistSchoolUnion:
        '/api/dataunion/reportnew/getschoolstudentscoredetaillist', //获取学生答题明细
      exportstudentscoredetaillistdownloadSchoolUnion:
        '/api/dataunion/reportnew/exportschoolstudentscoredetaillistdownload', //下载学生答题明细
      // 分组，独立分析表下载
      exportindependentmultireport:
        '/api/v1/reportnew/exportindependentmultireport', //总分下载
      exportindependentsinglereport:
        '/api/v1/reportnew/exportindependentsinglereport', //单科下载
      getscorelineanalysiscomparison:
        '/api/v1/reportnew/getscorelineanalysiscomparison', //上线分析对比
      exportscorelineanalysiscomparison:
        '/api/v1/reportnew/exportscorelineanalysiscomparison', //下载上线分析对比表
      studenttranscriptcontrastlist:
        '/api/v1/reportnew/studenttranscriptcontrastlist', //学生进退步
      exportstudenttranscriptcontrast:
        '/api/v1/reportnew/exportstudenttranscriptcontrast', //导出学生进退步
      getcompareavgscorelist: '/api/v1/reportnew/getcompareavgscorelist', //均分分析对比
      exportcompareavgscoretable:
        '/api/v1/reportnew/exportcompareavgscoretable', //下载均分分析对比
      examcomparisonset: '/api/v1/reportnew/examcomparisonset', //获取是否设置数据对比
      getschoolcampuslist: '/api/v1/exam/getschoolcampuslist', // 获取学校校区列表（权限）

      updatestudentvisiblestatus: '/edu/exammain/updatestudentvisiblestatus', // 修改学生可见
      getsubjectclasslist: '/api/v1/exam/getsubjectclasslist', // 通过考试获取学科
      getchoicequestionslist: '/api/dataunion/reportnew/getchoicequestionslist', // 选择题整体分析表
      getmultiscoreratelist: '/api/dataunion/reportnew/getmultiscoreratelist', // 全学科得分率分布
      getexamdatainfo: '/api/dataunion/exam/getexamdatainfo', // 单科整体信度
      getsinglescoreratelist: '/api/dataunion/reportnew/getsinglescoreratelist', // 分数段学生占比
      comparisonofschoolaveragegrades:
        '/api/dataunion/reportnew/comparisonofschoolaveragegrades', // 多维指标占比
      differentiationgradedistribution:
        '/api/dataunion/reportnew/differentiationgradedistribution', // 区分度整体分析
      questionoverallanalysis:
        '/api/dataunion/reportnew/questionoverallanalysis', // 试题整体分析
      difficultgradedistribution:
        '/api/dataunion/reportnew/difficultgradedistribution', // 试题难度等级分布
      getfourpointareacontrastlist:
        '/api/dataunion/reportnew/getfourpointareacontrastlist', // 全科四率（分区）对比
      getexamarealist: '/api/dataunion/reportnew/getexamarealist' // 获取区域
    }
  },
  centerApi: {
    host: process.env.VUE_APP_API_userApi,
    token: true,
    path: {
      getschoolgrantreport: '/api/report/getschoolgrantreport', // 获得 报表菜单
      userAuth: '/api/user/getuserinfo', // 获得 用户的信息
      getschoolreport: '/api/report/getschoolreport' // 获取报表授权情况
    }
  },
  examApi: {
    host: process.env.VUE_APP_API_xyapiexam,
    token: true,
    path: {
      getevastudentpage: '/api/evastudent/page', // 学生评价获取列
      getevastudentsave: '/api/evastudent/save', // 创建保存 学生评价
      getevastudenttasklist: '/api/eva/getevastudenttasklist', // 评价详情列表
      getevastudentscoredetail: '/api/eva/getevastudentscoredetail', // 学生评价详情列表---图表
      deletestudentscore: '/api/evastudent/delete', // 学生评价列表删除
      downloaderrorfile: '/api/evastudent/downloaderrorfile', // 下载导入错误原因
      GetClass: '/api/Assistant/GetClass', //获取班级
      getexamsvariants: '/api/variant/getexamsvariants', //考试巩固练获取列表
      getunionexamsvariants: '/api/union/variant/getunionexamsvariants', //联考巩固练获取列表
      createexamvariant: '/api/variant/createexamvariant', //考试巩固练发布
      createunionexamvariant: '/api/union/variant/createunionexamvariant', //联考巩固练发布
      obtainexamquestions: '/api/qp/obtainexamquestions', //考试巩固练,获取题目信息
      getdownloadclasses: '/api/variant/getdownloadclasses', //考试巩固练-下载班级详情
      getuniondownloadclasses: '/api/union/variant/getuniondownloadclasses', //考试巩固练-下载联考班级详情
      deleteexamvariant: '/api/variant/deleteexamvariant', //考试巩固练-删除
      deleteunionexamvariant: '/api/union/variant/deleteunionexamvariant', //联考-删除
      publishexamvariant: '/api/variant/publishexamvariant', //考试巩固练-发布成功
      publishunionexamvariant: '/api/union/variant/publishunionexamvariant', //联考巩固练-发布成功
      updateexamquestionurl: '/api/qp/updateexamquestionurl', //重新获取到url的题目并修改
      GetKnowledgePointTree: '/api/QuestionBank/GetKnowledgePointTree', //知识点树
      checkthestatusofquestions: '/api/qp/checkthestatusofquestions', //验证题目
      topicvalidation: '/api/qp/topicvalidation', //跳过验证和编辑完成
      deletequestionexamvariantbyid: '/api/qp/deletequestionexamvariantbyid', //通过Id进行题目删除
      gettestvariantdetails: '/api/qp/gettestvariantdetails', //验证题目获取详情
      getquestiontype: '/api/qp/getquestiontype', // 获取试题类型，全品
      changethequestion: '/api/qp/changethequestion', //换一题
      savechangethequestion: '/api/qp/savechangethequestion', //替换题目
      getgroupstudentlis: '/api/variant/getgroupstudentlist' //获取 学生分组
    }
  },
  baseApi: {
    host: process.env.VUE_APP_API_xyapibase,
    token: true,
    path: {
      //gradeAllList: '/api/schoolgrade/getallgrade', // TODO 所有年级列表
      getschoolyearandsemester: '/api/schoolyear/getschoolyearandsemester' // TODO  学年 学期 获取
    }
  },
  testApi: {
    host: process.env.VUE_APP_API_test,
    withCredentials: false,
    token: true,
    path: {
      getgrades: '/api/basicexam/getallgrade', // 添加考试-年级列表
      delreportinfo: '/api/v1/testonline/delreportinfo', // 清理考试缓存
      getonlineratebymeId: '/api/examination/getonlineratebymeId', //获取上线率
      saveonlinerate: '/api/examination/saveonlinerate', //设置上线率
      getevagrade: '/api/basicExam/GetGrade', // 获取学期
      getevayear: '/api/basicExam/GetYear', // 获取学年
      getareainfoandstudentscore: '/api/v1/scan/getareainfoandstudentscore', //获取试卷痕迹
      imgRotate: '/api/v1/image/rotate', //旋转图片
      getonlineinfoandstudentscore: '/api/v1/scan/getonlineinfoandstudentscore', //线上考试试卷图片
      getsingleexammarkingstatus: '/api/v1/summary/getsingleexammarkingstatus', //获取批阅状态
      getareainfoandstudentitemscore:
        '/api/v1/scan/getareainfoandstudentitemscore', // 答题情况试卷图片 （试卷讲评）
      getonlineinfoandstudentitemscore:
        '/api/v1/scan/getonlineinfoandstudentitemscore', //答题情况，线上考试试卷图片 （试卷讲评）
      getreportsettings: '/api/settings/getreportsettings', //获取是否家长可见
      getsingleexammarkingstatusunion:
        '/api/testunion/exam/getsingleexammarkingstatus', //联考的获取批阅状态
      delreportcache: '/api/testunion/reportpolicy/delreportcache', //清理联考和校考报表缓存
      markTemplete: '/api/v1/scan/getareainfo',
      downloadexamreportzip: '/api/v1/report/downloadexamreportzip',
      getExamImg: '/api/v1/scan/page' //试卷图片
    }
  },
  dataApi: {
    host: process.env.VUE_APP_API_defaulteApi,
    withCredentials: false,
    token: true,
    path: {
      getreportcontentsetting: '/api/examsetting/getstrategysetting', //获取策略配置(总分)
      getreleaseway: '/api/examsetting/getstrategysettingbycourseid', //策略设置单科获取
      updatereportcontentsetting: '/api/examsetting/updatestrategysetting', //保存报表内容总分
      updatestrategysettingbycourseid:
        '/api/examsetting/updatestrategysettingbycourseid', //保存单科策略设置
      recoverstrategysetting: '/api/examsetting/recoverstrategysetting', //恢复默认总分
      saveexamsettingbycourses: '/api/examsetting/saveexamsettingbycourses', //单科策略设置保存
      getdistinctiveclass: '/api/v1/reportnew/getdistinctiveclass' //获取组别
    }
  },
  test: {
    host: process.env.VUE_APP_API_test,
    withCredentials: false,
    token: true,
    path: {
      getSubject: '/api/basicExam/GetCourse', // 获取学科
      getlevelassignpoints: '/api/levelassignpoints/getlevelassignpoints', //等级赋分
      savelevelassignpoints: '/api/levelassignpoints/savelevelassignpoints', //保存等级赋分
      restorelevelassignpoints:
        '/api/levelassignpoints/restorelevelassignpoints', //重置等级赋分
      setofdisciplines: '/api/levelassignpoints/setofdisciplines', //获取已设置学科
      saveexammultigatherpolicy: '/api/examsetting/saveexammultigatherpolicy', // 保存等级赋分
      getexammultigatherpolicy: '/api/examsetting/getexammultigatherpolicy', //获取策略设置总分和单科
      setofexams: '/api/examsetting/setofexams', //获取学科
      restoredefault: '/api/examsetting/restoredefault', //恢复默认值
      initializepolicydata: '/api/examsetting/initializepolicydata' //策略去初始化
    }
  },
  downApi: {
    host: process.env.VUE_APP_API_downApi,
    withCredentials: false,
    token: true,
    path: {
      GetClassQuestionsDetailForExamViriantBatchID:
        '/api/ExamReport/GetClassQuestionsDetailForExamViriantBatchID', //获取学生进度batchID（个性错题本班级详情考试）
      DownLoadClassQuestionsDetailForExamViriantBatch:
        '/api/ExamReport/DownLoadClassQuestionsDetailForExamViriantBatch', // 获取学生进度（下载班级考试详情版）
      DownLoadClassQuestionsDetailForExamViriantBatchBureau:
        '/api/ExamReport/DownLoadClassQuestionsDetailForExamViriantBatchBureau' // 获取学生进度联考（下载班级考试详情版）
    }
  },
  webHM: {}
}
